

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
export interface selectObject {
  id: string;
  name: string;
  type: string;
}

@Component({
  name: 'lb-table-nav',
})
export default class extends Vue {
  private queryKey: string = '';
  private localMonth: string = '';
  private activeIndex: number = -1;
  private typeIndex: string = '';
  private selectList: selectObject[] = [
    {
      id: 'day',
      name: '当天',
      type: '1',
    },
    {
      id: 'week',
      name: '本周',
      type: '2',
    },
    {
      id: 'month',
      name: '本月',
      type: '3',
    },
    {
      id: 'quarter',
      name: '本季度',
      type: '4',
    },
    {
      id: 'all',
      name: '全部',
      type: '',
    },
  ];

  private handleClickSpan(index: number, type: string) {
    this.typeIndex = type;
    this.activeIndex = index;
    this.localMonth = '';
    const obj = {
      queryKey: this.queryKey,
      time_month: this.localMonth,
      typeIndex: this.typeIndex,
    };
    this.$emit('filter', obj);
  }
  private handleMonthChange(val: string) {
    this.activeIndex = -1;
    const obj = {
      queryKey: this.queryKey,
      time_month: !val ? '' : val,
      typeIndex: '',
    };
    this.$emit('filter', obj);
  }
  private handleSearch(val: string) {
    this.$emit('inputEnter', val);
  }
  private handleClear() {
    const obj = {
      queryKey: '',
      time_month: this.localMonth,
      typeIndex: this.typeIndex,
    };
    this.$emit('filter', obj);
  }
  private reset() {
    this.localMonth = '';
    this.typeIndex = '';
    this.queryKey = '';
    this.activeIndex = -1;
  }
}
